<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/1 md:w-1/3 sm:mt-3">
      <div class="vx-col sm:w-1/1">
        <span>Od</span>
      </div>
      <div class="vx-col sm:w-1/1">
        <flat-pickr
          v-model="dateObject.dateFrom"
          class="w-full"
          :config="config"
        ></flat-pickr>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/1 md:w-1/3 sm:mt-3">
      <div class="vx-col sm:w-1/1">
        <span>Do</span>
      </div>
      <div class="vx-col sm:w-1/1">
        <flat-pickr
          v-model="dateObject.dateTo"
          class="w-full"
          :config="config"
        ></flat-pickr>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/1 md:w-1/3 flex items-end sm:mt-3">
      <vs-button class="w-full" @click="$emit('search-clicked')"
        >Išči</vs-button
      >
    </div>
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: { flatPickr },
  data() {
    return {
      config: {
        dateFormat: "Z",
        altFormat: "d.m.Y",
        altInput: true,
      },
    };
  },
  props: {
    dateObject: {
      type: Object,
    },
  },
  mounted() {
    // setting dateTo to last day of the month
    this.dateObject.dateTo = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
  },
};
</script>